import { APP_INITIALIZER, InjectionToken, NgModule } from "@angular/core";
import {
  BrowserModule,
  BrowserTransferStateModule,
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AddFileModalComponent, AppComponent } from "./app.component";
import { AuthLayoutComponent } from "./auth-layout/auth-layout.component";
import { ToastrModule } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPermissionsModule } from "ngx-permissions";
import { CookieService } from "ngx-cookie-service";
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MsalRedirectComponent,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from "@azure/msal-angular";

import { AuthGuard } from "./shared/guard/auth.guard";
import { MyHttpInterceptor } from "./shared/interceptor/interceptor";
import { CommonService } from "./shared/services/common.service";

import {
  msalInstanceFactory,
  msalGuardConfigFactory,
  msalInterceptorConfigFactory,
  initializeApp,
} from "./msal.factories";
import { TimeagoModule } from "ngx-timeago";
import { CanvasLibraryModule } from "../lib";
import { NgPipesModule } from "ngx-pipes";
import { PipeModule } from "./shared/pipes/pipe.module";
import { ParadeExistingModalDialogComponent } from "./pages/parade/parade-existing-modal/parade-existing-modal";
import { ParadeCreateModalDialogComponent } from "./pages/parade/parade-create-modal/parade-create-modal";
import { SharedModule } from "./shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { NotificationRedirectComponent } from "./pages/notification-redirect/notification-redirect.component";

export const APP_NAME = new InjectionToken<string>("APP_NAME");

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AddFileModalComponent,
    ParadeExistingModalDialogComponent,
    ParadeCreateModalDialogComponent,
    NotificationRedirectComponent,
  ],
  imports: [
    BrowserModule,
    BrowserTransferStateModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    NgxPermissionsModule.forRoot(),
    MsalModule,
    TimeagoModule.forRoot(),
    PipeModule.forRoot(),
    NgPipesModule,
    CanvasLibraryModule,
    SharedModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [CommonService],
      multi: true,
    },
    { provide: APP_NAME, useValue: "rubin" },
    AuthGuard,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    CookieService,
    CommonService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
